import Blazy from 'blazy';

/**
 * Runs the Blazy lazy loading library with the specified options.
 * 
 * @param {object} options - The configuration options for Blazy.
 * @param {string} imageFallback - Specify fallback image whenever getting error.
 */
const runBlazy = (options, imageFallback) => {
  const imgFallback = imageFallback || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg==';

  new Blazy({
    breakpoints: [
      {
        width: 480, // max-width
        src: 'data-src-small'
      },
      {
        width: 1280, // max-width
        src: 'data-src'
      },
      {
        width: 1920, // max-width
        src: 'data-src-large'
      }
    ],
    loadInvisible: false,
    error: (ele, msg) => {
      if (msg !== 'missing' && msg !== 'invalid') {
        return;
      }

      if (ele.tagName == 'DIV' || ele.tagName == 'SECTION') {
        ele.style.background = `url(${imgFallback})`;
      } else {
        ele.setAttribute('data-src', imgFallback);
        ele.setAttribute('data-src-small', imgFallback);
      }
    },
    ...options
  });
};

export default runBlazy;
